import React = require("react");
import { LimaIconProps } from "./DefLimaIconType";

export const LimaIconToolsSearch = ({
  size = 32, // or any default size of your choice
  color = "black", // or any color of your choice
  title = "", //title
}: LimaIconProps): JSX.Element => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 24 24"
    //   width={size} // added size here
    //   height={size} // added size here
    //   fill={color} // added color here
    //   aria-labelledby="title"
    // >
    //   <title id="title">{title}</title>
    //   <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
    //   <path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z" />
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size} // added size here
      height={size} // added size here
      fill={color} // added color here
      aria-labelledby="title"
      viewBox="0 0 32 32"
    >
      <title id="title">{title}</title>
      <g id="Search" transform="translate(-291.57 -84.384)">
        <rect
          id="Rectangle_24139"
          data-name="Rectangle 24139"
          width="32"
          height="32"
          transform="translate(291.57 84.384)"
          fill="none"
        />
        <g id="Group_13264" data-name="Group 13264" transform="translate(-1.508 -2.025)">
          <g
            id="Ellipse_2272"
            data-name="Ellipse 2272"
            transform="translate(294.57 88.384)"
            fill="none"
            stroke="#8e8e93"
            strokeWidth="1.5"
          >
            <circle cx="11.909" cy="11.909" r="11.909" stroke="none" />
            <circle cx="11.909" cy="11.909" r="11.159" fill="none" />
          </g>
          <path
            id="Path_9025"
            data-name="Path 9025"
            d="M317.077,111.085l-7.065-7.065"
            transform="translate(5.169 3.964)"
            fill="none"
            stroke="#8e8e93"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
};
